import {defineComponent,h,ref,onUnmounted} from 'vue';
import {artifactReference} from '@knowyet/sdk/evidence';

/** The host supplies a bounded preview and an immutable, complete text-cell workbook. */
export const RecordPreview=defineComponent({
 props:{records:{type:Object,required:true},loadArtifact:{type:Function,required:true},disabled:Boolean},
 setup(props){
  const busy=ref(false),error=ref('');let controller:AbortController|undefined;
  onUnmounted(()=>controller?.abort());
  const validated=()=>{
   const r=props.records as any,download=artifactReference(r.download);
   if(!Array.isArray(r.columns)||!r.columns.length||r.columns.length>12||!r.columns.every((v:any)=>typeof v==='string')||
      !Array.isArray(r.rows)||r.rows.length>20||!r.rows.every((row:any)=>Array.isArray(row)&&row.length===r.columns.length&&row.every((v:any)=>typeof v==='string'))||
      !Number.isSafeInteger(r.total)||r.total<r.rows.length||download.media_type!=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')throw Error('invalid records');
   return {...r,download};
  };
  const download=async()=>{
   controller?.abort();controller=new AbortController();busy.value=true;error.value='';
   try{const r=validated(),response=await props.loadArtifact(r.download,controller.signal);if(!response.ok)throw Error('download');
    const blob=await response.blob();controller.signal.throwIfAborted();const url=URL.createObjectURL(blob),a=document.createElement('a');
    a.href=url;a.download='source-records.xlsx';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
   }catch{if(!controller.signal.aborted)error.value='完整明细下载失败，请重试。';}finally{busy.value=false;}
  };
  return()=>{let r;try{r=validated();}catch{return h('p',{role:'alert'},'明细引用不完整，暂时无法下载。');}
   return h('section',{'data-testid':'record-preview','aria-label':'完整明细'},[
    h('strong',`筛选结果共 ${r.total} 行`),h('p',{class:'muted'},`预览 ${r.rows.length} 行；下载文件包含全部 ${r.total} 行及来源信息。${r.preview_shortened?'较长文字在预览中已缩略。':''}`),
    h('div',{class:'answer-table'},[h('table',[h('thead',[h('tr',r.columns.map((c:string)=>h('th',c)))]),h('tbody',r.rows.map((row:string[])=>h('tr',row.map(c=>h('td',{style:{whiteSpace:'pre-wrap'}},c)))))])]),
    h('button',{type:'button',disabled:busy.value||props.disabled,onClick:download},busy.value?'正在下载…':'下载完整明细（Excel）'),error.value?h('p',{role:'alert'},error.value):null
   ]);
  };
 }
});
